import { Textarea } from "@coval/ui"

import { FieldLabel } from "./FieldLabel"

interface RealtimeInstructionsFieldProps {
  value?: string
  onChange: (value: string) => void
  disabled?: boolean
  className?: string
  placeholder?: string
}

export const RealtimeInstructionsField: React.FC<
  RealtimeInstructionsFieldProps
> = ({ value, onChange, disabled, className = "", placeholder }) => (
  <div className="space-y-2">
    <FieldLabel tooltip="Instructions sent to the agent for each conversation. Leave blank to use the model defaults.">
      Agent System Instructions
    </FieldLabel>
    <Textarea
      value={value || ""}
      onChange={(event) => onChange(event.target.value)}
      className={`text-sm ${className}`}
      disabled={disabled}
      rows={4}
      aria-label="Agent System Instructions"
      placeholder={placeholder}
    />
  </div>
)
